// extracted by mini-css-extract-plugin
export var banner = "_41-0";
export var icon = "_41-1";
export var message = "_41-2";